import { ref, type Ref, watch, onBeforeUnmount } from 'vue';

const activeDropdownId: Ref<symbol | null> = ref(null);

export function useDropdownManager() {
  const dropdownId = Symbol();
  const isOpen = ref(false);

  const open = () => {
    activeDropdownId.value = dropdownId;
    isOpen.value = true;
  };

  const close = () => {
    if (activeDropdownId.value === dropdownId) {
      activeDropdownId.value = null;
    }
    isOpen.value = false;
  };

  const toggle = () => {
    if (isOpen.value) {
      close();
    } else {
      open();
    }
  };

  // Watch for other dropdowns opening
  const stopWatch = watch(activeDropdownId, (newId) => {
    if (newId !== dropdownId && isOpen.value) {
      isOpen.value = false;
    }
  });

  onBeforeUnmount(() => {
    stopWatch();
    if (activeDropdownId.value === dropdownId) {
      activeDropdownId.value = null;
    }
  });

  return { isOpen, open, close, toggle };
}
